export default "__VITE_ASSET__Bv614Tm1__"